import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}

class VariantStockStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestUpdateTarget = this.closest('.shopify-section, dialog, product-card');
    closestUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestUpdateTarget = this.closest('.shopify-section, dialog, product-card');
    closestUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  /**
   * Updates variant stock status from section-rendered HTML.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const context = this.dataset.stockContext;
    if (!context) return;

    const selector = `variant-stock-status[data-stock-context="${context}"]`;
    const newStatus = event.detail.data.html.querySelector(selector);
    if (!newStatus) return;

    this.className = newStatus.className;
    this.dataset.stockStatus = newStatus.dataset.stockStatus;
    morph(this, newStatus, { childrenOnly: true });
  };
}

if (!customElements.get('variant-stock-status')) {
  customElements.define('variant-stock-status', VariantStockStatus);
}
